// // SalesEnquiries.js
// import React, { useState, useEffect } from 'react';
// import { salesService } from '../../service/Vendorservisefile/salesService.jsx';
// import './SalesEnquiries.css';

// const SalesEnquiries = () => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [enquiries, setEnquiries] = useState([]);
//   const [statsData, setStatsData] = useState([]);
//   const [enquiryStatusCards, setEnquiryStatusCards] = useState([]);
//   const [projectStatusCards, setProjectStatusCards] = useState([]);
//   const [recentEnquiriesData, setRecentEnquiriesData] = useState([]);
//   const [pipelineData, setPipelineData] = useState({ stages: [], counts: [], values: [] });

//   // Fetch data on component mount
//   useEffect(() => {
//     fetchEnquiries();
//   }, []);

//   const fetchEnquiries = async () => {
//     try {
//       setLoading(true);
//       const data = await salesService.getAllEnquiries();
      
//       // Filter out invalid enquiries (empty project name, etc.)
//       const validEnquiries = data.filter(enquiry => 
//         enquiry.projectName && enquiry.projectName.trim() !== ''
//       );
      
//       setEnquiries(validEnquiries);
//       updateDashboardData(validEnquiries);
//       setError(null);
//     } catch (err) {
//       console.error('Failed to fetch enquiries:', err);
//       setError('Failed to load enquiries. Please try again later.');
//       // Set some default data for demo
//       setDefaultData();
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateDashboardData = (enquiryData) => {
//     // Calculate all stats
//     const stats = salesService.getEnquiryStats(enquiryData);
//     const pipeline = salesService.getPipelineStages(enquiryData);
//     const enquiryStatusDist = salesService.getEnquiryStatusDistribution(enquiryData);
//     const projectStatusDist = salesService.getProjectStatusDistribution(enquiryData);
//     const recent = salesService.getRecentEnquiries(enquiryData);

//     // Update stats cards
//     const newStatsData = [
//       { id: 'stat-sourcing', label: 'SOURCING', value: pipeline.stageCounts['Sourcing'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Sourcing'] || 0)}` },
//       { id: 'stat-enquiry', label: 'ENQUIRY', value: pipeline.stageCounts['Enquiry'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Enquiry'] || 0)}` },
//       { id: 'stat-quote', label: 'QUOTE', value: pipeline.stageCounts['Quote'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Quote'] || 0)}` },
//       { id: 'stat-approval', label: 'APPROVAL', value: pipeline.stageCounts['Approval'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Approval'] || 0)}` },
//       { id: 'stat-po', label: 'PO', value: 0, sub: '₹0' }, // Not in data
//       { id: 'stat-execution', label: 'EXECUTION', value: pipeline.stageCounts['Execution'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Execution'] || 0)}` },
//       { id: 'stat-payment', label: 'PAYMENT', value: pipeline.stageCounts['Payment'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Payment'] || 0)}` },
//       { id: 'stat-pending', label: 'PENDING', value: stats.pendingValue > 0 ? 1 : 0, sub: `₹${salesService.formatBudgetValue(stats.pendingValue)} pending` },
//     ];
//     setStatsData(newStatsData);

//     // Update enquiry status cards
//     const newEnquiryStatusCards = [
//       { name: 'Pending Quote', count: enquiryStatusDist['Pending Quote'] || 0, value: '₹0', color: 'pending' },
//       { name: 'Quote Submitted', count: enquiryStatusDist['Quote Submitted'] || 0, value: '₹0', color: 'submitted' },
//       { name: 'Approved', count: enquiryStatusDist['Approved'] || 0, value: '₹0', color: 'approved' },
//       { name: 'Rejected', count: enquiryStatusDist['Rejected'] || 0, value: '₹0', color: 'rejected' },
//       { name: 'Revision', count: enquiryStatusDist['Revision'] || 0, value: '₹0', color: 'revision' },
//     ];
//     setEnquiryStatusCards(newEnquiryStatusCards);

//     // Update project status cards
//     const newProjectStatusCards = [
//       { name: 'Initiated', count: projectStatusDist['Initiated'] || 0, value: '₹0', color: 'initiated' },
//       { name: 'In Progress', count: projectStatusDist['In Progress'] || 0, value: '₹0', color: 'progress' },
//       { name: 'Completed', count: projectStatusDist['Completed'] || 0, value: '₹0', color: 'completed' },
//     ];
//     setProjectStatusCards(newProjectStatusCards);

//     // Update recent enquiries
//     setRecentEnquiriesData(recent);

//     // Update pipeline data
//     const stages = ['Sourcing', 'Enquiry', 'Quote', 'Approval', 'PO', 'Execution', 'Payment'];
//     setPipelineData({
//       stages: stages,
//       counts: stages.map(stage => pipeline.stageCounts[stage] || 0),
//       values: stages.map(stage => `₹${salesService.formatBudgetValue(pipeline.stageValues[stage] || 0)}`),
//     });
//   };

//   const setDefaultData = () => {
//     // Fallback data if API fails
//     const defaultStats = [
//       { id: 'stat-sourcing', label: 'SOURCING', value: '4', sub: '₹11,95,000' },
//       { id: 'stat-enquiry', label: 'ENQUIRY', value: '2', sub: '₹2,75,000' },
//       { id: 'stat-quote', label: 'QUOTE', value: '1', sub: '₹9,20,000' },
//       { id: 'stat-approval', label: 'APPROVAL', value: '1', sub: '₹9,20,000' },
//       { id: 'stat-po', label: 'PO', value: '1', sub: '₹9,20,000' },
//       { id: 'stat-execution', label: 'EXECUTION', value: '1', sub: '₹9,20,000' },
//       { id: 'stat-payment', label: 'PAYMENT', value: '2', sub: '₹9,20,000' },
//       { id: 'stat-pending', label: 'PENDING', value: '3', sub: '₹5,35,000 pending' },
//     ];
//     setStatsData(defaultStats);

//     setEnquiryStatusCards([
//       { name: 'Pending Quote', count: 1, value: '₹0', color: 'pending' },
//       { name: 'Quote Submitted', count: 1, value: '₹2,75,000', color: 'submitted' },
//       { name: 'Approved', count: 1, value: '₹9,20,000', color: 'approved' },
//       { name: 'Rejected', count: 0, value: '₹0', color: 'rejected' },
//       { name: 'Revision', count: 0, value: '₹0', color: 'revision' },
//     ]);

//     setProjectStatusCards([
//       { name: 'Initiated', count: 0, value: '₹0', color: 'initiated' },
//       { name: 'In Progress', count: 1, value: '₹9,20,000', color: 'progress' },
//       { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
//     ]);

//     setRecentEnquiriesData([
//       { id: 'ENQ-X1Y2Z', client: 'Acme Industries', quote: '₹9,20,000', status: 'Approved', clientStatus: 'Accepted', owner: 'Priya (Exec)' },
//       { id: 'ENQ-M3N4O', client: 'Acme Industries', quote: '₹2,75,000', status: 'Quote Submitted', clientStatus: 'Negotiation', owner: 'Karan (Exec)' },
//       { id: 'ENQ-59AHL', client: 'Orbit Logistics', quote: '—', status: 'Pending Quote', clientStatus: '—', owner: 'Priya (Exec)' },
//     ]);
//   };

//   // Loading state
//   if (loading) {
//     return (
//       <div className="vks-dashboard-container">
//         <div className="vks-loading">Loading enquiries...</div>
//       </div>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <div className="vks-dashboard-container">
//         <div className="vks-error">{error}</div>
//       </div>
//     );
//   }

//   return (
//     <div className="vks-dashboard-container">
//       <div className="vks-dashboard-wrapper">
//         {/* Top Stats Grid - 8 cards */}
//         <div className="vks-top-stats-grid">
//           {statsData.map((stat) => (
//             <div key={stat.id} className="vks-top-stat-card">
//               <div className="vks-top-stat-label">{stat.label}</div>
//               <div className="vks-top-stat-value">{stat.value}</div>
//               {stat.sub && <div className="vks-top-stat-sub">{stat.sub}</div>}
//             </div>
//           ))}
//         </div>

//         {/* Two Column Layout: Enquiry Status + Project Status */}
//         <div className="vks-two-column-layout">
//           {/* Enquiry Status Cards Section */}
//           <div className="vks-enquiry-status-area">
//             <h2 className="vks-section-heading">Enquiry status</h2>
//             <div className="vks-status-cards-grid">
//               {enquiryStatusCards.map((card, idx) => (
//                 <div key={idx} className={`vks-status-card vks-status-card-${card.color}`}>
//                   <div className="vks-status-card-name">{card.name}</div>
//                   <div className="vks-status-card-count">{card.count}</div>
//                   <div className="vks-status-card-value">{card.value}</div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Project Status Cards Section */}
//           <div className="vks-project-status-area">
//             <h2 className="vks-section-heading">Project status</h2>
//             <div className="vks-status-cards-grid">
//               {projectStatusCards.map((card, idx) => (
//                 <div key={idx} className={`vks-status-card vks-status-card-${card.color}`}>
//                   <div className="vks-status-card-name">{card.name}</div>
//                   <div className="vks-status-card-count">{card.count}</div>
//                   <div className="vks-status-card-value">{card.value}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Recent Enquiries Section with View All link */}
//         <div className="vks-recent-area">
//           <div className="vks-recent-header">
//             <h2 className="vks-section-heading">Recent enquiries</h2>
//             <a href="#" className="vks-view-all-link">View all →</a>
//           </div>
          
//           <div className="vks-table-wrapper">
//             <table className="vks-data-table">
//               <thead>
//                 <tr className="vks-table-header-row">
//                   <th className="vks-table-header">ID</th>
//                   <th className="vks-table-header">CLIENT</th>
//                   <th className="vks-table-header">QUOTE</th>
//                   <th className="vks-table-header">STATUS</th>
//                   <th className="vks-table-header">CLIENT STATUS</th>
//                   <th className="vks-table-header">OWNER</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {recentEnquiriesData.length > 0 ? (
//                   recentEnquiriesData.map((row, idx) => (
//                     <tr key={idx} className="vks-table-row">
//                       <td className="vks-table-cell">{row.id}</td>
//                       <td className="vks-table-cell">{row.projectName}</td>
//                       <td className="vks-table-cell">{row.quote}</td>
//                       <td className="vks-table-cell">
//                         <span className={`vks-status-badge vks-badge-${row.status.toLowerCase().replace(/\s+/g, '-')}`}>
//                           {row.status}
//                         </span>
//                       </td>
//                       <td className="vks-table-cell">
//                         {row.clientStatus !== '—' ? (
//                           <span className={`vks-client-badge vks-client-${row.clientStatus.toLowerCase()}`}>
//                             {row.clientStatus}
//                           </span>
//                         ) : (
//                           <span className="vks-client-badge vks-client-empty">—</span>
//                         )}
//                       </td>
//                       <td className="vks-table-cell">{row.owner}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="6" className="vks-table-cell vks-no-data">No enquiries found</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalesEnquiries;




import React, { useState, useEffect } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { salesService } from '../../service/Vendorservisefile/salesService.jsx';
import './SalesEnquiries.css';

// Fixed color maps so chart colors always match the status card colors
const ENQUIRY_COLORS = {
  'Pending Quote': '#f59e0b',
  'Quote Submitted': '#3b82f6',
  'Approved': '#10b981',
  'Rejected': '#ef4444',
  'Revision': '#a855f7',
};

const PROJECT_COLORS = {
  'Initiated': '#64748b',
  'In Progress': '#3b82f6',
  'Completed': '#10b981',
};

// Custom tooltip for both pie charts
const ChartTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) return null;
  const { name, value } = payload[0];
  return (
    <div className="vks-pie-tooltip">
      <span className="vks-pie-tooltip-name">{name}</span>
      <span className="vks-pie-tooltip-value">{value}</span>
    </div>
  );
};

// Renders % label only for slices big enough to fit text
const renderPieLabel = ({ percent }) => (percent > 0.06 ? `${Math.round(percent * 100)}%` : '');

const getInitials = (name = '') =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();

const AVATAR_PALETTE = ['#6366f1', '#0ea5e9', '#f59e0b', '#10b981', '#ec4899', '#8b5cf6'];
const avatarColorFor = (seed = '') => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};

const SalesEnquiries = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [enquiries, setEnquiries] = useState([]);
  const [statsData, setStatsData] = useState([]);
  const [enquiryStatusCards, setEnquiryStatusCards] = useState([]);
  const [projectStatusCards, setProjectStatusCards] = useState([]);
  const [recentEnquiriesData, setRecentEnquiriesData] = useState([]);
  const [pipelineData, setPipelineData] = useState({ stages: [], counts: [], values: [] });

  // Fetch data on component mount
  useEffect(() => {
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      setLoading(true);
      const data = await salesService.getAllEnquiries();

      // Filter out invalid enquiries (empty project name, etc.)
      const validEnquiries = data.filter(
        (enquiry) => enquiry.projectName && enquiry.projectName.trim() !== ''
      );

      setEnquiries(validEnquiries);
      updateDashboardData(validEnquiries);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch enquiries:', err);
      setError('Failed to load enquiries. Please try again later.');
      // Set some default data for demo
      setDefaultData();
    } finally {
      setLoading(false);
    }
  };

  const updateDashboardData = (enquiryData) => {
    // Calculate all stats
    const stats = salesService.getEnquiryStats(enquiryData);
    const pipeline = salesService.getPipelineStages(enquiryData);
    const enquiryStatusDist = salesService.getEnquiryStatusDistribution(enquiryData);
    const projectStatusDist = salesService.getProjectStatusDistribution(enquiryData);
    const recent = salesService.getRecentEnquiries(enquiryData);

    // Update stats cards
    const newStatsData = [
      { id: 'stat-sourcing', label: 'SOURCING', value: pipeline.stageCounts['Sourcing'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Sourcing'] || 0)}` },
      { id: 'stat-enquiry', label: 'ENQUIRY', value: pipeline.stageCounts['Enquiry'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Enquiry'] || 0)}` },
      { id: 'stat-quote', label: 'QUOTE', value: pipeline.stageCounts['Quote'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Quote'] || 0)}` },
      { id: 'stat-approval', label: 'APPROVAL', value: pipeline.stageCounts['Approval'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Approval'] || 0)}` },
      { id: 'stat-po', label: 'PO', value: 0, sub: '₹0' }, // Not in data
      { id: 'stat-execution', label: 'EXECUTION', value: pipeline.stageCounts['Execution'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Execution'] || 0)}` },
      { id: 'stat-payment', label: 'PAYMENT', value: pipeline.stageCounts['Payment'] || 0, sub: `₹${salesService.formatBudgetValue(pipeline.stageValues['Payment'] || 0)}` },
      { id: 'stat-pending', label: 'PENDING', value: stats.pendingValue > 0 ? 1 : 0, sub: `₹${salesService.formatBudgetValue(stats.pendingValue)} pending` },
    ];
    setStatsData(newStatsData);

    // Update enquiry status cards
    const newEnquiryStatusCards = [
      { name: 'Pending Quote', count: enquiryStatusDist['Pending Quote'] || 0, value: '₹0', color: 'pending' },
      { name: 'Quote Submitted', count: enquiryStatusDist['Quote Submitted'] || 0, value: '₹0', color: 'submitted' },
      { name: 'Approved', count: enquiryStatusDist['Approved'] || 0, value: '₹0', color: 'approved' },
      { name: 'Rejected', count: enquiryStatusDist['Rejected'] || 0, value: '₹0', color: 'rejected' },
      { name: 'Revision', count: enquiryStatusDist['Revision'] || 0, value: '₹0', color: 'revision' },
    ];
    setEnquiryStatusCards(newEnquiryStatusCards);

    // Update project status cards
    const newProjectStatusCards = [
      { name: 'Initiated', count: projectStatusDist['Initiated'] || 0, value: '₹0', color: 'initiated' },
      { name: 'In Progress', count: projectStatusDist['In Progress'] || 0, value: '₹0', color: 'progress' },
      { name: 'Completed', count: projectStatusDist['Completed'] || 0, value: '₹0', color: 'completed' },
    ];
    setProjectStatusCards(newProjectStatusCards);

    // Update recent enquiries
    setRecentEnquiriesData(recent);

    // Update pipeline data
    const stages = ['Sourcing', 'Enquiry', 'Quote', 'Approval', 'PO', 'Execution', 'Payment'];
    setPipelineData({
      stages: stages,
      counts: stages.map((stage) => pipeline.stageCounts[stage] || 0),
      values: stages.map((stage) => `₹${salesService.formatBudgetValue(pipeline.stageValues[stage] || 0)}`),
    });
  };

  const setDefaultData = () => {
    // Fallback data if API fails
    const defaultStats = [
      { id: 'stat-sourcing', label: 'SOURCING', value: '4', sub: '₹11,95,000' },
      { id: 'stat-enquiry', label: 'ENQUIRY', value: '2', sub: '₹2,75,000' },
      { id: 'stat-quote', label: 'QUOTE', value: '1', sub: '₹9,20,000' },
      { id: 'stat-approval', label: 'APPROVAL', value: '1', sub: '₹9,20,000' },
      { id: 'stat-po', label: 'PO', value: '1', sub: '₹9,20,000' },
      { id: 'stat-execution', label: 'EXECUTION', value: '1', sub: '₹9,20,000' },
      { id: 'stat-payment', label: 'PAYMENT', value: '2', sub: '₹9,20,000' },
      { id: 'stat-pending', label: 'PENDING', value: '3', sub: '₹5,35,000 pending' },
    ];
    setStatsData(defaultStats);

    setEnquiryStatusCards([
      { name: 'Pending Quote', count: 1, value: '₹0', color: 'pending' },
      { name: 'Quote Submitted', count: 1, value: '₹2,75,000', color: 'submitted' },
      { name: 'Approved', count: 1, value: '₹9,20,000', color: 'approved' },
      { name: 'Rejected', count: 0, value: '₹0', color: 'rejected' },
      { name: 'Revision', count: 0, value: '₹0', color: 'revision' },
    ]);

    setProjectStatusCards([
      { name: 'Initiated', count: 0, value: '₹0', color: 'initiated' },
      { name: 'In Progress', count: 1, value: '₹9,20,000', color: 'progress' },
      { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
    ]);

    setRecentEnquiriesData([
      { id: 'ENQ-X1Y2Z', client: 'Acme Industries', quote: '₹9,20,000', status: 'Approved', clientStatus: 'Accepted', owner: 'Priya (Exec)' },
      { id: 'ENQ-M3N4O', client: 'Acme Industries', quote: '₹2,75,000', status: 'Quote Submitted', clientStatus: 'Negotiation', owner: 'Karan (Exec)' },
      { id: 'ENQ-59AHL', client: 'Orbit Logistics', quote: '—', status: 'Pending Quote', clientStatus: '—', owner: 'Priya (Exec)' },
    ]);
  };

  // Loading state
  if (loading) {
    return (
      <div className="vks-dashboard-container">
        <div className="vks-loading">Loading enquiries...</div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="vks-dashboard-container">
        <div className="vks-error">{error}</div>
      </div>
    );
  }

  // Build pie chart data, skipping zero-count slices so the chart isn't cluttered
  const enquiryPieData = enquiryStatusCards
    .filter((c) => c.count > 0)
    .map((c) => ({ name: c.name, value: c.count }));

  const projectPieData = projectStatusCards
    .filter((c) => c.count > 0)
    .map((c) => ({ name: c.name, value: c.count }));

  return (
    <div className="vks-dashboard-container">
      <div className="vks-dashboard-wrapper">
        {/* Top Stats Grid - 8 cards */}
        <div className="vks-top-stats-grid">
          {statsData.map((stat) => (
            <div key={stat.id} className="vks-top-stat-card">
              <div className="vks-top-stat-label">{stat.label}</div>
              <div className="vks-top-stat-value">{stat.value}</div>
              {stat.sub && <div className="vks-top-stat-sub">{stat.sub}</div>}
            </div>
          ))}
        </div>

        {/* Two Column Layout: Enquiry Status + Project Status */}
        <div className="vks-two-column-layout">
          {/* Enquiry Status Section */}
          <div className="vks-enquiry-status-area">
            <h2 className="vks-section-heading">Enquiry status</h2>

            {/* Enquiry status pie chart */}
            <div className="vks-pie-card">
              {enquiryPieData.length > 0 ? (
                <ResponsiveContainer width="100%" height={260}>
                  <PieChart>
                    <Pie
                      data={enquiryPieData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      innerRadius={55}
                      outerRadius={90}
                      paddingAngle={3}
                      label={renderPieLabel}
                      labelLine={false}
                    >
                      {enquiryPieData.map((entry, idx) => (
                        <Cell key={idx} fill={ENQUIRY_COLORS[entry.name] || '#94a3b8'} stroke="none" />
                      ))}
                    </Pie>
                    <Tooltip content={<ChartTooltip />} />
                    <Legend
                      layout="horizontal"
                      verticalAlign="bottom"
                      iconType="circle"
                      wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              ) : (
                <div className="vks-pie-empty">No enquiry status data yet</div>
              )}
            </div>
          </div>

          {/* Project Status Section */}
          <div className="vks-project-status-area">
            <h2 className="vks-section-heading">Project status</h2>

            {/* Project status pie chart */}
            <div className="vks-pie-card">
              {projectPieData.length > 0 ? (
                <ResponsiveContainer width="100%" height={260}>
                  <PieChart>
                    <Pie
                      data={projectPieData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      innerRadius={55}
                      outerRadius={90}
                      paddingAngle={3}
                      label={renderPieLabel}
                      labelLine={false}
                    >
                      {projectPieData.map((entry, idx) => (
                        <Cell key={idx} fill={PROJECT_COLORS[entry.name] || '#94a3b8'} stroke="none" />
                      ))}
                    </Pie>
                    <Tooltip content={<ChartTooltip />} />
                    <Legend
                      layout="horizontal"
                      verticalAlign="bottom"
                      iconType="circle"
                      wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
                    />
                  </PieChart>
                </ResponsiveContainer>
              ) : (
                <div className="vks-pie-empty">No project status data yet</div>
              )}
            </div>
          </div>
        </div>

        {/* Recent Enquiries Section — premium card list */}
        <div className="vks-recent-area vks-recent-premium">
          <div className="vks-recent-header">
            <h2 className="vks-section-heading">Recent enquiries</h2>
            <a href="#" className="vks-view-all-link">View all →</a>
          </div>

          {recentEnquiriesData.length > 0 ? (
            <div className="vks-premium-list">
              {recentEnquiriesData.map((row, idx) => {
                const clientName = row.client || row.projectName || 'Unknown client';
                const statusSlug = (row.status || '').toLowerCase().replace(/\s+/g, '-');
                return (
                  <div key={idx} className="vks-premium-row">
                    <div className="vks-premium-avatar" style={{ background: avatarColorFor(clientName) }}>
                      {getInitials(clientName)}
                    </div>

                    <div className="vks-premium-main">
                      <div className="vks-premium-top-line">
                        <span className="vks-premium-client">{clientName}</span>
                        <span className="vks-premium-id">{row.id}</span>
                      </div>
                      <div className="vks-premium-bottom-line">
                        <span className="vks-premium-owner">{row.owner}</span>
                        {row.clientStatus && row.clientStatus !== '—' && (
                          <span className={`vks-client-badge vks-client-${row.clientStatus.toLowerCase()}`}>
                            {row.clientStatus}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="vks-premium-quote">{row.quote}</div>

                    <span className={`vks-status-badge vks-badge-${statusSlug}`}>{row.status}</span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="vks-no-data vks-premium-empty">No enquiries found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalesEnquiries;